/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.7.23",
    versionName: "0.2.0-nightly.2025.7.23",
    versionChannel: "nightly",
    buildDate: "2025-07-23T00:09:42.053Z",
    commitHash: "afb5e1679bd57ff5f6d8cb501724ad8da45fdc52",
};
